/**
 * @class ModalSection
 *
 * Contains data for modal section
 *
 * @property {string|React.ReactElement} data - data to be displayed in the section
 * @property {string} className - specific classes to be applied to this section
 */
export default class ModalSection {
    /**
     *
     * @param {string|React.ReactElement} [data] - data to be displayed in the section
     * @param {string} [className] - specific classes to be applied to the section
     */
    constructor(data = "", className = "") {
        this._className = className;
        this._data = data;
    }

    /**
     * @returns {string}
     */
    get className() {
        return this._className;
    }

    /**
     * @returns {string | React.ReactElement}
     */
    get data() {
        return this._data;
    }
}
